export default {
	namespaced: true,

	state: {
		locale: 'de',
		localeSetByBrowserPreference: false,
	},

	mutations: {
		setLocale(state, locale) {
			state.locale = locale
			document.documentElement.lang = locale
		},

		setLocaleSetByBrowserPreference(state, flag) {
			state.localeSetByBrowserPreference = flag
		},
	},
}
